<template>
  <div class="mod-invited">
    <div class="invited-content" v-if="inviterInfo">
      <img src="@/assets/img/invited.png"/>
      <h2><font class="invited_name">{{inviterInfo.inviteName}} {{inviterInfo.inviteUserName | formatPhone}}</font> 邀请您加入</h2>
      <h2>{{inviterInfo.companyName}}</h2>
      <el-button class="but-invit" type="primary" @click.stop="confirmHandle">接受邀请</el-button>
    </div>
    <div v-else class="invited-content">
      <h2>链接已过期</h2>
    </div>
    <el-dialog :visible.sync="visible"
                :close-on-click-modal="false"
                width="40%">
      <div slot="title" v-if="inviterInfo" class="dialog_title_invited">
        {{inviterInfo.inviteName}}{{inviterInfo.inviteUserName | formatPhone}}邀请您加入{{inviterInfo.companyName}}
      </div>
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()">
        <el-form-item prop="username">
          <el-input v-model="dataForm.username" :placeholder="loginFlag === 3 ? '登录账号' : '手机号码'" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item prop="name" v-if="loginFlag === 2">
          <el-input v-model="dataForm.name" placeholder="名字" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item prop="password" v-if="loginFlag !== 1">
          <el-input v-model="dataForm.password"
                    type="password"
                    :maxlength="13"
                    auto-complete="new-password"
                    placeholder="请输入您的密码"></el-input>
        </el-form-item>
        <el-form-item prop="rePassword" v-if="loginFlag === 2">
          <el-input v-model="dataForm.rePassword"
                    type="password"
                    :maxlength="13"
                    auto-complete="new-password"
                    placeholder="请再次输入您的密码"></el-input>
        </el-form-item>
        <el-form-item prop="messageCode" v-if="loginFlag !== 3">
          <el-input @paste.native.capture.prevent v-model="dataForm.messageCode" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" placeholder="验证码">
            <el-button slot="append" class="sendCode" native-type="button" @click="sendHande" :disabled="disabled">{{time > 0 ? (time + 's后重新获取') : '发送验证码'}}</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <el-button class="but-invit" type="primary" :loading="loading" @click="dataFormSubmitHandle()">{{loginFlag !== 2 ? '登录并接受邀请' : '注册并接受邀请'}}</el-button>
      <div class="crrent-status" v-show="loginFlag !==2" >
        <span class="crrent-status-item" @click.stop="changeStatus(2)">立即注册</span>
        <span class="crrent-status-item" v-show="loginFlag ===1" @click="changeStatus(3)">密码登录</span>
        <span class="crrent-status-item" v-show="loginFlag ===3" @click="changeStatus(1)">验证码登录</span>
      </div>
      <div class="align-right" v-show="loginFlag === 2">
        <span class="crrent-status-item" @click.stop="changeStatus(1)">已有账号 去登录</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
import { phoneReg } from '@/utils/reg'
export default {
  data () {
    return {
      inviterInfo: null,
      visible: false,
      loginFlag: 1, // 1 login by mobile, 2 register, 3 login by password
      dataForm: {
        username: '',
        name: '',
        password: '',
        rePassword: '',
        requestId: '',
        messageCode: '',
        registerType: 1,
        appCode: window.SITE_CONFIG.appCode,
        clientId: 'android',
        registMode: 'PC' // 注册类型(微信、钉钉等)
      },
      disabled: false,
      time: 0,
      timeSet: null,
      loading: false
    }
  },
  filters: {
    formatPhone (val) {
      if (val && val !== '') {
        return val.substring(0, 3) + '*****' + val.substring(val.length - 2)
      } else {
        return ''
      }
    }
  },
  computed: {
    inviter () {
      return this.$route.params.id
    },
    haveToken () {
      let token = getAccessToken()
      let result = false
      if (token && token !== 'null' && token !== 'undefind' && token !== '') {
        result = true
      }
      return result
    },
    dataRule () {
      let validatePasswordLength = (rule, value, callback) => {
        if (value) {
          if (value.length < 8) {
            return callback(new Error('密码最低8位'))
          } else if (value.length > 13) {
            return callback(new Error('密码最多13位'))
          }
          // return callback(new Error('两次密码输入不一致'))
        }
        callback()
      }
      let validatePassword = (rule, value, callback) => {
        if (value && (value !== this.dataForm.password)) {
          return callback(new Error('两次密码输入不一致'))
        }
        callback()
      }
      return {
        username: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validatePasswordLength, trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validatePasswordLength, trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        messageCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    inviter: {
      handler: 'getInviterInfo',
      immediate: true
    }
  },
  methods: {
    // 获取邀请人信息
    getInviterInfo () {
      this.inviterInfo = null
      if (!this.inviter) {
        return false
      }
      this.$http.get(`/front/consumer/user/getInvitationInformation/${this.inviter}`)
        .then(({ data: res }) => {
          this.inviterInfo = res.data
        }).catch(() => {})
    },
    changeStatus (loginFlag) {
      this.time = 0
      this.disabled = false
      this.dataForm = {
        username: '',
        name: '',
        password: '',
        rePassword: '',
        requestId: '',
        messageCode: '',
        registerType: 1,
        appCode: window.SITE_CONFIG.appCode,
        clientId: 'android',
        registMode: 'PC' // 注册类型(微信、钉钉等)
      }
      this.loginFlag = loginFlag
    },
    confirmHandle () {
      if (this.haveToken) {
        // 已登陆
        // this.visible = true
        this.$http.post(`/front/consumer/user/loginJoinCompany`, {
          invitationCode: this.inviter
        })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success('加入企业成功')
            setTimeout(() => {
              this.$router.push({ name: 'basicInfo' })
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }, 1000)
          }).catch(() => {
          })
      } else {
        // 弹出登录或者注册提示框
        this.changeStatus(1)
        this.visible = true
      }
    },
    dataFormSubmitHandle () {
      if (this.loading) {
        return false
      }
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        const Base64 = require('js-base64').Base64
        let params = {
          ...this.dataForm,
          companyId: this.inviterInfo.companyId,
          invitationCode: this.inviter,
          password: Base64.encode(this.dataForm.password),
          loginType: this.loginFlag === 3 ? 'password' : this.loginFlag === 2 ? 'register' : 'sms'
        }
        if (this.loginFlag === 1) {
          params.name = ''
          params.password = ''
        } else if (this.loginFlag === 3) {
          // return this.loginByUserName()
        }
        this.loading = true
        this.$http.post(`/front/consumer/user/invitationRegister`, params)
          .then(({ data: res }) => {
            // this.$alert(res, '提示res', {
            //   confirmButtonText: '确定'
            // })
            this.loading = false
            if (res.code !== 0) {
              return false
            }
            Cookies.set('access_token_shop', res.data.access_token)
            this.visible = false
            this.bus.$emit('refushUserInfo')
            this.bus.$emit('getUserMenuPerm')
            this.$router.replace({ name: 'home' })
          }).catch(() => {
            // this.$alert(err, '提示', {
            //   confirmButtonText: '确定'
            // })
            this.loading = false
          })
      })
    },
    // 发送验证码
    sendHande () {
      if (this.disabled) {
        return false
      }
      // const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      if (this.dataForm.username === '') {
        this.$message({
          message: '手机号不能为空',
          type: 'warning'
        })
        return
      }
      if (!phoneReg.test(this.dataForm.username)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        })
        return false
      } else {
        this.disabled = true
        this.dataForm.requestId = ''
        // 快捷登录发送验证码
        this.$request.get(`/front/consumer/sendVerificationCode?mobile=${this.dataForm.username}`)
          .then((res) => {
            this.dataForm.requestId = res.requestId
            this.time = 60
            // if (this.timeSet) {
            //   clearTimeout(this.timeSet)
            // }
            setTimeout(this.timer, 1000)
            // this.timer()
            // Cookies.set('access_token', res.access_token)
            // this.$router.replace({ name: 'home' })
          }).catch(() => {
            this.disabled = false
          })
      }
    },
    // 60S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.$nextTick(() => {
          this.timeSet = setTimeout(this.timer, 1000)
        })
      } else {
        this.time = 0
        this.disabled = false
        // if (this.timeSet) {
        //   clearTimeout(this.timeSet)
        // }
      }
    }
  },
  destroyed () {
    if (this.timeSet) {
      clearTimeout(this.timeSet)
    }
  }
}
</script>
<style lang='scss' scoped>
.dialog_title_invited{
  color: #2e88ff;
}
.mod-invited{
  margin-top: 10px;
  background: #fff;
  padding: 50px 50px;
  .sendCode{
    background: #2e88ff;
    border-color: #2e88ff;
    color: #fff;
  }
  .but-invit{
    background: #2e88ff;
    border-color: #2e88ff;
    width: 100%;
  }
  .invited-content{
    width: 400px;
    margin: 0 auto;
    text-align: center;
    .invited_name{
      color: #1d65a8;
    }
  }
  .crrent-status{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }
  .align-right{
    margin-top: 10px;
  }
  .crrent-status-item{
    cursor: pointer;
    &:hover{
      color: #2e88ff;
    }
  }
}
</style>
